import { render, staticRenderFns } from "./receiveSign.vue?vue&type=template&id=567f4696&scoped=true"
import script from "./receiveSign.vue?vue&type=script&lang=js"
export * from "./receiveSign.vue?vue&type=script&lang=js"
import style0 from "./receiveSign.vue?vue&type=style&index=0&id=567f4696&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f4696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567f4696')) {
      api.createRecord('567f4696', component.options)
    } else {
      api.reload('567f4696', component.options)
    }
    module.hot.accept("./receiveSign.vue?vue&type=template&id=567f4696&scoped=true", function () {
      api.rerender('567f4696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/receiveSign.vue"
export default component.exports